import React from "react";
import { Select, SelectProps, Spin } from "antd";
import LogisticsCompany from "@/enum/LogisticsCompany";
import LogisticsCompanyNameMap from "@/map/LogisticsCompanyNameMap";
import { observer } from "mobx-react-lite";
import OrderDTO from "@/dto/order/OrderDTO";
import "./index.less";
import { useRequest } from "ahooks";
import { updateLogisticsCompany } from "@/services/api/order";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";

type Option = Exclude<SelectProps<LogisticsCompany>["options"], undefined>[number];

interface OrderLogisticsCompanySelectProps extends SelectProps<LogisticsCompany> {
    order: OrderDTO;
}

/**
 * 通用快递公司选择器组件
 * 支持两种模式：
 * 1. 普通模式 - 直接显示所有快递公司
 * 2. 优先模板模式 - 初始显示模板中的快递公司，支持搜索时加载/点击查看更多
 */
const OrderLogisticsCompanySelect: React.FC<OrderLogisticsCompanySelectProps> = observer((props) => {
    const { order } = props;
    const orderManagementStore = useOrderManagementStore();

    const allLogisticsCompanies = Object.keys(LogisticsCompany) as LogisticsCompany[];

    const options: Option[] = allLogisticsCompanies.map((logisticsCompany) => {
        const logisticsCompanyName = LogisticsCompanyNameMap[logisticsCompany];
        const label = logisticsCompanyName;

        return {
            label,
            value: logisticsCompany,
            "data-search-key": logisticsCompanyName,
        };
    });

    const { loading, runAsync } = useRequest(updateLogisticsCompany, { manual: true });

    async function handleLogisticsCompanyChange(value: LogisticsCompany) {
        if (!value) return;

        await runAsync([order], value);

        orderManagementStore.table.updateOrder(order.id, {
            logisticsCompany: value,
        });
    }

    return (
        <Spin spinning={loading}>
            <Select
                className="order-logistics-company-select"
                style={{ padding: 0, fontSize: "12px" }}
                // showSearch
                placeholder={
                    <span className="fs12" style={{ color: "rgb(86, 149, 196)" }}>
                        选择快递
                    </span>
                }
                size="small"
                options={options}
                value={order.logisticsCompany}
                variant="borderless"
                popupMatchSelectWidth={false}
                onChange={handleLogisticsCompanyChange}
            />
        </Spin>
    );
});

export default OrderLogisticsCompanySelect;
